import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { adminElevatorsRoutes } from './elevators/adminElevatorsRoutes';
import { agencyElevatorsRoutes } from './elevators/agencyElevatorsRoutes';
import { clientElevatorsRoutes } from './elevators/clientElevatorsRoutes';

const PREFIX = '/elevators';

const SwitchPage = lazy(() => import('../../../main/elevators/common/switch-page/SwitchPage'));

export const elevatorsRoutes: RouteObject[] = [
  {
    path: PREFIX + '',
    element: <SwitchPage />,
  },
  ...clientElevatorsRoutes,
  ...agencyElevatorsRoutes,
  ...adminElevatorsRoutes,
];
